import React from 'react'

const Loader = ({ loading, small = null, modifier = null }) => {
    return loading && (
        <div className={`row-loader-wrapper`}>
            <div className={`
                row-loader 
                ${small ? 'row-loader--small' : ''}
                ${modifier ? 'row-loader--' + modifier : ''}
            `}>
                <div></div><div></div><div></div>
            </div>
        </div>
    )
}

export default Loader